module.exports = __webpack_public_path__ + "static/media/bebedouro_industrial_lider.42853232.png";